import { FC } from "react";
import { Site } from "../../../lib/src/api/partner/models/Site";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Button } from "../../../lib/src/components/form/Button";
import { useModal } from "../../../lib/src/components/layout/ModalProvider";
import { CancelDeletionModal } from "../modals/CancelDeletionModal";
import { useApiClient } from "../../../lib/src/api";
import { usePermissions } from "../../../lib/src/auth/permissions";
import { config } from "../config";

export const PlannedRemovalBanner: FC<{ site: Site }> = ({ site }) => {
  const { partnerClient } = useApiClient(config)
  const { can } = usePermissions(partnerClient)
  const { open: openCancelModal } = useModal({ title: 'Cancel deletion', body: <CancelDeletionModal site={site} /> })
  if (site.removeAt !== null) {
    return <div className={"h-24 my-5 rounded-lg bg-red-500 border border-slate-100"}>
      <div className={"flex-1 px-6 h-full rounded-lg flex items-center justify-between bg-linear-to-r from-transparent from-20% to-red-500"}>
        <div>
          <h2 className={"font-medium text-xl text-white -mb-1"}>Site deletion pending</h2>
          <p className={"text text-red-50"}>
            This site will be deleted on <strong>{moment(site.removeAt).format('DD-MM-YYYY')}</strong>.
          </p>
        </div>
        {can('edit', 'sites', site.permissions) && <Button type={'primary'} size={'md'} text={'Cancel Deletion'} icon={faBan} onClick={() => openCancelModal()} />}
        <span className={"uppercase font-bold italic text-xl text-red-50 tracking-wider border border-red-400 px-2 rounded-sm"}>
          <FontAwesomeIcon icon={faExclamationTriangle} className={'mr-2'} />
          Warning!
        </span>
      </div>
    </div>
  }
  return <></>
}
